/*
Office Supplies
 */

const name = 'Office Supplies'
const id = 'uC0CpwaIbtRQ3fRWi5fb'

export default {
  name,
  id
}
